import React from "react";
import {
  CONTACT_CATEGORY,
  getEligibleCategoriesFromSubRoles,
  getContactDesignationFromRow,
} from "../utils/requestContactDesignations";

const OPTIONS = [
  { value: "none", label: "Not a Request Contact" },
  { value: "request", label: "Request Contact" },
  { value: "primary", label: "Primary Contact" },
];

export default function ContactDesignationSection({
  selectedRoles = [],
  rfiDesignation,
  assessmentDesignation,
  onRfiChange,
  onAssessmentChange,
}) {
  const eligible = getEligibleCategoriesFromSubRoles(selectedRoles);
  const showRfi = eligible.includes(CONTACT_CATEGORY.RFI);
  const showAssessment = eligible.includes(CONTACT_CATEGORY.ASSESSMENT);

  if (!showRfi && !showAssessment) return null;

  const renderGroup = (category, legend, helper, value, onChange, name) => (
    <fieldset>
      <legend className="text-sm/6 font-medium text-gray-900">{legend}</legend>
      <p className="mt-1 text-sm/6 text-gray-500">{helper}</p>
      <div className="mt-4 space-y-4">
        {OPTIONS.map((option) => (
          <div key={`${name}-${option.value}`} className="flex items-center">
            <input
              id={`${name}-designation-${option.value}`}
              name={`${name}-designation`}
              type="radio"
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            />
            <label
              htmlFor={`${name}-designation-${option.value}`}
              className="ml-3 block text-sm/6 font-medium text-gray-900"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </fieldset>
  );

  return (
    <div className="border-b border-gray-900/10 pb-12 mb-8">
      <h2 className="text-base/7 font-semibold text-gray-900">Request Contact Designation</h2>
      <p className="mt-1 text-sm/6 text-gray-600">
        Designate whether this user appears as a request contact option when requesting VQQs or assessments from this vendor organization.
      </p>
      <div className="mt-10 space-y-10">
        {showRfi &&
          renderGroup(
            CONTACT_CATEGORY.RFI,
            "VQQ Request Contact",
            "Controls whether this user appears as a contact option in VQQ request forms.",
            rfiDesignation,
            onRfiChange,
            "rfi",
          )}
        {showAssessment &&
          renderGroup(
            CONTACT_CATEGORY.ASSESSMENT,
            "Assessment Request Contact",
            "Controls whether this user appears as a contact option in assessment request forms.",
            assessmentDesignation,
            onAssessmentChange,
            "assessment",
          )}
      </div>
    </div>
  );
}

export { getContactDesignationFromRow };
